/* SH Collection — L1 pill nav scroll-spy + scroll-position preservation + LINE FAB scroll-react
   2026-05-25 · vanilla · no deps · ~3 KB minified
   Safe to load on any collection page; auto-skips if elements absent */
(function () {
  'use strict';

  /* ============================================================
     1) STICKY PILL NAV — scroll-spy on L1 (best-seller hub)
        Highlights current section · click = smooth scroll
     ============================================================ */
  function initPillNav() {
    var nav = document.querySelector('.sh-coll-pillnav');
    if (!nav) return;
    var pills = nav.querySelectorAll('.sh-coll-pillnav__pill');
    if (!pills.length) return;

    // Build target map
    var targets = [];
    pills.forEach(function (pill) {
      var sel = pill.getAttribute('href');
      if (!sel || sel[0] !== '#') return;
      var el = document.querySelector(sel);
      if (el) targets.push({ pill: pill, el: el });
    });
    if (!targets.length) return;

    // Smooth scroll on click
    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        var sel = pill.getAttribute('href');
        if (!sel || sel[0] !== '#') return;
        var el = document.querySelector(sel);
        if (!el) return;
        e.preventDefault();
        var navH = nav.getBoundingClientRect().height;
        var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sh-coll-header-h')) || 56;
        var offset = headerH + navH + 8;
        var rect = el.getBoundingClientRect();
        var top = window.pageYOffset + rect.top - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        // Update URL hash without jump
        history.replaceState(null, '', sel);
      });
    });

    // Scroll-spy via IntersectionObserver
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        targets.forEach(function (t) {
          if (t.el === entry.target) {
            pills.forEach(function (p) { p.classList.remove('is-active'); });
            t.pill.classList.add('is-active');
            // Auto-scroll pill into view if overflows
            try {
              t.pill.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
            } catch (_) {}
          }
        });
      });
    }, {
      rootMargin: '-30% 0px -55% 0px',
      threshold: 0
    });
    targets.forEach(function (t) { io.observe(t.el); });

    // Floated shadow when scrolled
    var floatIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        nav.classList.toggle('is-floated', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;position:absolute;top:0;left:0;width:100%;';
    if (nav.parentNode) {
      nav.parentNode.insertBefore(sentinel, nav);
      floatIO.observe(sentinel);
    }
  }

  /* ============================================================
     2) SCROLL POSITION PRESERVATION
        On navigation away from collection page, save scrollY.
        On return (back nav), restore.
     ============================================================ */
  function initScrollPreserve() {
    if (!document.body.classList.contains('hdt-template-collection')) return;
    var key = 'sh-coll-scroll-' + location.pathname;

    // Restore on load
    var saved = sessionStorage.getItem(key);
    if (saved) {
      var y = parseFloat(saved);
      if (!isNaN(y) && y > 0) {
        // Wait for layout settle (lazy images may shift)
        var restored = false;
        var tryRestore = function () {
          if (restored) return;
          window.scrollTo(0, y);
          restored = true;
        };
        if (document.readyState === 'complete') {
          requestAnimationFrame(tryRestore);
        } else {
          window.addEventListener('load', function () {
            requestAnimationFrame(tryRestore);
          });
        }
        // Clear after restore so refresh doesn't trap user
        setTimeout(function () { sessionStorage.removeItem(key); }, 1500);
      }
    }

    // Save before navigating away
    var saveScroll = function () {
      sessionStorage.setItem(key, String(window.pageYOffset));
    };
    // Save when clicking a product link (will navigate to PDP)
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/products/') > -1) saveScroll();
    });
    // Also save on visibility-change (page-hide)
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') saveScroll();
    });
  }

  /* ============================================================
     3) FLOATING LINE FAB — scroll-direction-reactive
        Hide on scroll DOWN · show on scroll UP
     ============================================================ */
  function initFab() {
    var fab = document.querySelector('.sh-coll-fab');
    if (!fab) return;
    var lastY = window.pageYOffset;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset;
        var down = y > lastY && y > 200;
        fab.classList.toggle('is-hidden', down);
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ============================================================
     4) BOTTOM SHEET — open/close logic (used by L3 filter)
     ============================================================ */
  function initSheets() {
    document.addEventListener('click', function (e) {
      // Trigger open
      var trig = e.target.closest && e.target.closest('[data-sh-sheet-open]');
      if (trig) {
        var id = trig.getAttribute('data-sh-sheet-open');
        var sh = document.getElementById(id);
        if (sh) {
          sh.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        return;
      }
      // Trigger close
      var clos = e.target.closest && e.target.closest('[data-sh-sheet-close]');
      if (clos) {
        var sheet = clos.closest('.sh-coll-sheet');
        if (sheet) {
          sheet.classList.remove('is-open');
          document.body.style.overflow = '';
        }
        return;
      }
      // Click backdrop (outside panel) to close
      if (e.target.classList && e.target.classList.contains('sh-coll-sheet')) {
        e.target.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });

    // ESC to close
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openSheets = document.querySelectorAll('.sh-coll-sheet.is-open');
      openSheets.forEach(function (s) {
        s.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ============================================================
     5) L3 SORT DROPDOWN — change → URL navigation
     ============================================================ */
  function initSort() {
    document.querySelectorAll('[data-sh-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page'); // reset to page 1 on sort change
        location.href = url.toString();
      });
    });
  }

  /* ============================================================
     6) L3 FILTER FORM — submit on change OR via apply button
     ============================================================ */
  function initFilterForm() {
    document.querySelectorAll('[data-sh-filter-form]').forEach(function (form) {
      // Visual state update on checkbox change (no submit yet · wait for apply)
      form.addEventListener('change', function (e) {
        if (e.target.type !== 'checkbox') return;
        var label = e.target.closest('.sh-coll-filter-chip');
        if (label) label.classList.toggle('is-active', e.target.checked);
      });

      // On submit · build URL with filter params + sort + reset page
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var url = new URL(location.href);
        // Clear all existing filter params
        Array.from(url.searchParams.keys()).forEach(function (k) {
          if (k.indexOf('filter.') === 0) url.searchParams.delete(k);
        });
        url.searchParams.delete('page');
        // Apply current filter values
        var fd = new FormData(form);
        fd.forEach(function (val, key) {
          if (val !== '' && val !== '0') url.searchParams.append(key, val);
        });
        location.href = url.toString();
      });
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    initPillNav();
    initScrollPreserve();
    initFab();
    initSheets();
    initSort();
    initFilterForm();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
